// Cart Drawer Recommendation Add to Cart Handler
document.addEventListener('DOMContentLoaded', function() {
  // Handle add to cart for recommendation product - ONLY in cart drawer
  document.addEventListener('click', function(e) {
    // Check if clicked element is the recommendation add to cart button IN THE CART DRAWER
    const button = e.target.closest('.you-may-also-like .recommendation-product__button');
    if (!button) return;
    
    // Prevent default form submission
    e.preventDefault();
    e.stopPropagation();
    
    // Get the form
    const form = button.closest('form');
    if (!form) return;
    
    // Disable button and show loading state
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    
    // Get form data
    const formData = new FormData(form);
    
    // Convert to object for JSON submission
    const data = {
      items: [{
        id: formData.get('id'),
        quantity: 1
      }]
    };
    
    // Add to cart via AJAX
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      // Re-enable button
      button.disabled = false;
      button.textContent = originalText;
      
      // Refresh the cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.refreshHTML) {
        cartDrawer.refreshHTML();
      }
      
      // Keep drawer open
      if (cartDrawer && !cartDrawer.classList.contains('active')) {
        cartDrawer.open();
      }
      
      // Optional: Show success message
      button.textContent = 'Added!';
      setTimeout(() => {
        button.textContent = originalText;
      }, 1500);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.disabled = false;
      button.textContent = originalText;
    });
  });
});